import { render, staticRenderFns } from "./previewleasecontract.vue?vue&type=template&id=2c8b89fc&scoped=true"
import script from "./previewleasecontract.vue?vue&type=script&lang=js"
export * from "./previewleasecontract.vue?vue&type=script&lang=js"
import style0 from "./previewleasecontract.vue?vue&type=style&index=0&id=2c8b89fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b89fc",
  null
  
)

export default component.exports